// Shared visual presets for game backgrounds, fonts, alignments

export const FONT_FAMILIES = [
  { value: "Fredoka", label: "Fredoka" },
  { value: "Inter", label: "Inter" },
  { value: "Roboto", label: "Roboto" },
  { value: "Poppins", label: "Poppins" },
  { value: "Comic Neue", label: "Comic Neue" },
  { value: "Lato", label: "Lato" },
  { value: "Montserrat", label: "Montserrat" },
  { value: "Nunito", label: "Nunito" },
];

export const TEXT_ALIGNS = [
  { value: "left", label: "Esquerda" },
  { value: "center", label: "Centro" },
  { value: "right", label: "Direita" },
];

export const BG_GRADIENTS = [
  // Linear
  { id: "sky", label: "Céu (Azul)", css: "linear-gradient(135deg, #60a5fa 0%, #3b82f6 50%, #1e3a8a 100%)" },
  { id: "ocean", label: "Oceano", css: "linear-gradient(135deg, #06b6d4 0%, #0e7490 100%)" },
  { id: "sunset", label: "Pôr-do-sol", css: "linear-gradient(135deg, #fb923c 0%, #f43f5e 100%)" },
  { id: "forest", label: "Floresta", css: "linear-gradient(135deg, #34d399 0%, #047857 100%)" },
  { id: "rose", label: "Rosa", css: "linear-gradient(135deg, #fbcfe8 0%, #ec4899 100%)" },
  { id: "lavender", label: "Lavanda", css: "linear-gradient(135deg, #c4b5fd 0%, #7c3aed 100%)" },
  { id: "mint", label: "Menta", css: "linear-gradient(135deg, #a7f3d0 0%, #10b981 100%)" },
  { id: "midnight", label: "Meia-noite", css: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)" },
  // Multi-stop / vibrantes
  { id: "rainbow", label: "Arco-íris", css: "linear-gradient(135deg, #ef4444 0%, #f59e0b 25%, #facc15 50%, #22c55e 70%, #3b82f6 90%, #a855f7 100%)" },
  { id: "candy", label: "Doce", css: "linear-gradient(135deg, #fbb6ce 0%, #93c5fd 50%, #c4b5fd 100%)" },
  { id: "tropical", label: "Tropical", css: "linear-gradient(135deg, #fde68a 0%, #f97316 35%, #ec4899 70%, #8b5cf6 100%)" },
  { id: "aurora", label: "Aurora", css: "linear-gradient(135deg, #22d3ee 0%, #818cf8 40%, #c084fc 70%, #f472b6 100%)" },
  { id: "neon", label: "Neon", css: "linear-gradient(135deg, #0ea5e9 0%, #d946ef 50%, #f43f5e 100%)" },
  { id: "peach", label: "Pêssego", css: "linear-gradient(135deg, #fed7aa 0%, #fb7185 100%)" },
  { id: "lemon", label: "Limão", css: "linear-gradient(135deg, #fef9c3 0%, #84cc16 100%)" },
  { id: "grape", label: "Uva", css: "linear-gradient(135deg, #c084fc 0%, #6d28d9 100%)" },
  { id: "fire", label: "Fogo", css: "linear-gradient(135deg, #facc15 0%, #fb923c 40%, #ef4444 100%)" },
  { id: "ice", label: "Gelo", css: "linear-gradient(135deg, #e0f2fe 0%, #7dd3fc 100%)" },
  // Radiais e cónicos
  { id: "radial-sky", label: "Radial Céu", css: "radial-gradient(ellipse at top, #93c5fd 0%, #1e3a8a 100%)" },
  { id: "radial-warm", label: "Radial Quente", css: "radial-gradient(circle at 50% 30%, #fde68a 0%, #fb923c 50%, #be123c 100%)" },
  { id: "radial-galaxy", label: "Galáxia", css: "radial-gradient(ellipse at 50% 50%, #4c1d95 0%, #1e1b4b 60%, #020617 100%)" },
  { id: "conic", label: "Cónico vibrante", css: "conic-gradient(from 180deg at 50% 50%, #06b6d4, #3b82f6, #8b5cf6, #ec4899, #f59e0b, #06b6d4)" },
  // Pastéis suaves
  { id: "pastel-mint", label: "Pastel Menta", css: "linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)" },
  { id: "pastel-blue", label: "Pastel Azul", css: "linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%)" },
  { id: "pastel-yellow", label: "Pastel Amarelo", css: "linear-gradient(135deg, #fef9c3 0%, #fde68a 100%)" },
  { id: "pastel-pink", label: "Pastel Rosa", css: "linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%)" },
  // Escuros premium
  { id: "deep-purple", label: "Roxo Profundo", css: "linear-gradient(135deg, #312e81 0%, #6d28d9 100%)" },
  { id: "deep-teal", label: "Verde-azulado", css: "linear-gradient(135deg, #134e4a 0%, #0d9488 100%)" },
  { id: "deep-crimson", label: "Carmesim", css: "linear-gradient(135deg, #7f1d1d 0%, #be123c 100%)" },
  { id: "deep-night", label: "Noite Estrelada", css: "linear-gradient(135deg, #0c0a3e 0%, #1d4ed8 50%, #0c4a6e 100%)" },
];

export const BG_SOLIDS = [
  { id: "#f8fafc", label: "Branco gelo" },
  { id: "#ffffff", label: "Branco puro" },
  { id: "#fef3c7", label: "Amarelo claro" },
  { id: "#fde68a", label: "Amarelo médio" },
  { id: "#dbeafe", label: "Azul claro" },
  { id: "#bfdbfe", label: "Azul céu" },
  { id: "#dcfce7", label: "Verde claro" },
  { id: "#bbf7d0", label: "Verde menta" },
  { id: "#fce7f3", label: "Rosa claro" },
  { id: "#fbcfe8", label: "Rosa pastel" },
  { id: "#fee2e2", label: "Vermelho claro" },
  { id: "#fecaca", label: "Coral suave" },
  { id: "#ede9fe", label: "Lilás claro" },
  { id: "#ddd6fe", label: "Lavanda" },
  { id: "#fed7aa", label: "Pêssego" },
  { id: "#a7f3d0", label: "Esmeralda claro" },
  { id: "#cffafe", label: "Ciano claro" },
  { id: "#e0e7ff", label: "Índigo claro" },
  { id: "#f3e8ff", label: "Roxo claro" },
  { id: "#1e293b", label: "Cinzento escuro" },
  { id: "#0f172a", label: "Azul-marinho" },
  { id: "#000000", label: "Preto" },
];

export const BG_PATTERNS = [
  { id: "stripes", label: "Riscas diagonais", css: "repeating-linear-gradient(45deg, #e0f2fe 0 24px, #bae6fd 24px 48px)" },
  { id: "stripes-bold", label: "Riscas largas", css: "repeating-linear-gradient(45deg, #fef3c7 0 40px, #fde68a 40px 80px)" },
  { id: "stripes-vertical", label: "Riscas verticais", css: "repeating-linear-gradient(90deg, #f1f5f9 0 20px, #e2e8f0 20px 40px)" },
  { id: "stripes-horizontal", label: "Riscas horizontais", css: "repeating-linear-gradient(0deg, #fef9c3 0 20px, #fef3c7 20px 40px)" },
  { id: "stripes-rainbow", label: "Riscas arco-íris", css: "repeating-linear-gradient(45deg, #fecaca 0 24px, #fed7aa 24px 48px, #fef08a 48px 72px, #bbf7d0 72px 96px, #bfdbfe 96px 120px, #e9d5ff 120px 144px)" },
  { id: "dots", label: "Pontos pequenos", css: "radial-gradient(circle, #94a3b8 1.5px, transparent 1.5px) 0 0/22px 22px, #f1f5f9" },
  { id: "dots-large", label: "Pontos grandes", css: "radial-gradient(circle, #60a5fa 4px, transparent 4px) 0 0/40px 40px, #eff6ff" },
  { id: "dots-pink", label: "Pontos rosa", css: "radial-gradient(circle, #ec4899 2px, transparent 2px) 0 0/28px 28px, #fdf2f8" },
  { id: "polka", label: "Polka offset", css: "radial-gradient(circle at 25% 25%, #fbbf24 5px, transparent 5px) 0 0/50px 50px, radial-gradient(circle at 75% 75%, #fbbf24 5px, transparent 5px) 0 0/50px 50px, #fef3c7" },
  { id: "grid", label: "Grelha clara", css: "linear-gradient(#e2e8f0 1px, transparent 1px) 0 0/30px 30px, linear-gradient(90deg, #e2e8f0 1px, transparent 1px) 0 0/30px 30px, #f8fafc" },
  { id: "grid-bold", label: "Grelha forte", css: "linear-gradient(#cbd5e1 2px, transparent 2px) 0 0/40px 40px, linear-gradient(90deg, #cbd5e1 2px, transparent 2px) 0 0/40px 40px, #f8fafc" },
  { id: "blueprint", label: "Blueprint", css: "linear-gradient(rgba(255,255,255,.4) 1px, transparent 1px) 0 0/25px 25px, linear-gradient(90deg, rgba(255,255,255,.4) 1px, transparent 1px) 0 0/25px 25px, #1d4ed8" },
  { id: "graphpaper", label: "Papel quadriculado", css: "linear-gradient(#cbd5e1 1px, transparent 1px) 0 0/20px 20px, linear-gradient(90deg, #cbd5e1 1px, transparent 1px) 0 0/20px 20px, linear-gradient(#94a3b8 1px, transparent 1px) 0 0/100px 100px, linear-gradient(90deg, #94a3b8 1px, transparent 1px) 0 0/100px 100px, #f1f5f9" },
  { id: "waves", label: "Ondas suaves", css: "repeating-radial-gradient(circle at 50% -10%, #e0f2fe 0 30px, #bae6fd 30px 60px)" },
  { id: "waves-sea", label: "Ondas do mar", css: "repeating-radial-gradient(circle at 50% 100%, #0891b2 0 35px, #0e7490 35px 70px)" },
  { id: "checkers", label: "Xadrez", css: "linear-gradient(45deg, #e2e8f0 25%, transparent 25%) 0 0/40px 40px, linear-gradient(-45deg, #e2e8f0 25%, transparent 25%) 0 0/40px 40px, linear-gradient(45deg, transparent 75%, #e2e8f0 75%) 0 0/40px 40px, linear-gradient(-45deg, transparent 75%, #e2e8f0 75%) 0 0/40px 40px, #f8fafc" },
  { id: "checkers-color", label: "Xadrez colorido", css: "linear-gradient(45deg, #fbcfe8 25%, transparent 25%) 0 0/48px 48px, linear-gradient(-45deg, #fbcfe8 25%, transparent 25%) 0 0/48px 48px, linear-gradient(45deg, transparent 75%, #fbcfe8 75%) 0 0/48px 48px, linear-gradient(-45deg, transparent 75%, #fbcfe8 75%) 0 0/48px 48px, #fdf2f8" },
  { id: "confetti", label: "Confetti", css: "radial-gradient(circle at 10% 20%, #fbbf24 0 4px, transparent 4px), radial-gradient(circle at 70% 50%, #f472b6 0 3px, transparent 3px), radial-gradient(circle at 30% 80%, #60a5fa 0 4px, transparent 4px), radial-gradient(circle at 90% 30%, #34d399 0 3px, transparent 3px), #fefce8" },
  { id: "confetti-night", label: "Confetti noturno", css: "radial-gradient(circle at 10% 20%, #fde047 0 4px, transparent 4px), radial-gradient(circle at 70% 50%, #f472b6 0 3px, transparent 3px), radial-gradient(circle at 30% 80%, #93c5fd 0 4px, transparent 4px), radial-gradient(circle at 90% 30%, #86efac 0 3px, transparent 3px), #1e293b" },
  { id: "triangles", label: "Triângulos", css: "linear-gradient(60deg, #c7d2fe 50%, transparent 50%) 0 0/40px 70px, linear-gradient(-60deg, #c7d2fe 50%, transparent 50%) 0 0/40px 70px, #eef2ff" },
  { id: "zigzag", label: "Ziguezague", css: "linear-gradient(135deg, #fde68a 25%, transparent 25%) 0 0/30px 30px, linear-gradient(225deg, #fde68a 25%, transparent 25%) 0 0/30px 30px, linear-gradient(315deg, #fde68a 25%, transparent 25%) 0 0/30px 30px, linear-gradient(45deg, #fde68a 25%, transparent 25%) 0 0/30px 30px, #fef9c3" },
  { id: "diamonds", label: "Diamantes", css: "linear-gradient(45deg, #c4b5fd 25%, transparent 25%, transparent 75%, #c4b5fd 75%) 0 0/40px 40px, linear-gradient(45deg, #c4b5fd 25%, transparent 25%, transparent 75%, #c4b5fd 75%) 20px 20px/40px 40px, #ede9fe" },
  { id: "hex", label: "Favo de mel", css: "radial-gradient(circle farthest-side at 0% 50%, #fde68a 23.5%, transparent 0) 0 0/40px 70px, radial-gradient(circle farthest-side at 0% 50%, #fef3c7 24%, transparent 0) 20px 35px/40px 70px, #fef9c3" },
  { id: "circuit", label: "Circuito", css: "linear-gradient(90deg, transparent 95%, #38bdf8 95%) 0 0/30px 30px, linear-gradient(0deg, transparent 95%, #38bdf8 95%) 0 0/30px 30px, #0c4a6e" },
  { id: "starry", label: "Estrelas", css: "radial-gradient(2px 2px at 20px 30px, #fef3c7, transparent), radial-gradient(2px 2px at 60px 80px, #fde68a, transparent), radial-gradient(1px 1px at 90px 50px, #fef9c3, transparent), radial-gradient(2px 2px at 130px 110px, #fde047, transparent), #0f172a 0 0/160px 160px" },
  { id: "bubbles", label: "Bolhas", css: "radial-gradient(circle at 20% 30%, rgba(186,230,253,.6) 0 30px, transparent 30px), radial-gradient(circle at 70% 60%, rgba(186,230,253,.4) 0 50px, transparent 50px), radial-gradient(circle at 90% 20%, rgba(186,230,253,.5) 0 25px, transparent 25px), #e0f2fe" },
  { id: "math-paper", label: "Papel matemático", css: "linear-gradient(rgba(59,130,246,.25) 1px, transparent 1px) 0 0/25px 25px, linear-gradient(90deg, rgba(59,130,246,.25) 1px, transparent 1px) 0 0/25px 25px, #fefce8" },
];

export function getBackgroundCss(visual) {
  if (!visual) return BG_GRADIENTS[0].css;
  const type = visual.bg_type || "gradient";
  const value = visual.bg_value || "sky";
  if (type === "gradient") {
    return (BG_GRADIENTS.find((g) => g.id === value) || BG_GRADIENTS[0]).css;
  }
  if (type === "pattern") {
    return (BG_PATTERNS.find((g) => g.id === value) || BG_PATTERNS[0]).css;
  }
  if (type === "solid") {
    return value; // hex color
  }
  if (type === "image" && visual.bg_image_url) {
    return `center/cover no-repeat url("${visual.bg_image_url}")`;
  }
  return BG_GRADIENTS[0].css;
}

export function getQuestionTextStyle(visual) {
  if (!visual) return {};
  return {
    fontFamily: visual.font_family ? `"${visual.font_family}", sans-serif` : undefined,
    color: visual.font_color || undefined,
    fontSize: visual.font_size ? `${visual.font_size}px` : undefined,
    fontWeight: visual.font_bold ? 800 : 500,
    fontStyle: visual.font_italic ? "italic" : "normal",
    textAlign: visual.text_align || "center",
  };
}

export const DEFAULT_VISUAL = {
  font_family: "Fredoka",
  font_color: "#0F172A",
  font_size: 18,
  font_bold: true,
  font_italic: false,
  text_align: "center",
  bg_type: "gradient",
  bg_value: "sky",
  bg_image_url: null,
  card_front_border_color: "#03060f",
  card_front_border_width: 22,
  roulette_border_color: "#03060f",
  roulette_border_width: 22,
  roulette_mini_font_family: "Fredoka",
  roulette_mini_font_size: 9,
  roulette_mini_font_color: "#334155",
  roulette_mini_font_bold: true,
  roulette_reveal_size: 115,
  roulette_reveal_offset_x: 0,
  roulette_reveal_offset_y: 0,
  roulette_reveal_effect_enabled: true,
  roulette_reveal_effect: "spring",
  small_letter_outline_color: "#000000",
  small_letter_outline_width: 0.5,
  small_letter_outline_mode: "solid",
  small_letter_outline_color2: "#666666",
  cycle_letter_outline_color: "#000000",
  cycle_letter_outline_width: 0.5,
  cycle_letter_outline_mode: "solid",
  cycle_letter_outline_color2: "#666666",
  reveal_outline_color: "#000000",
  reveal_outline_width: 0.5,
  reveal_outline_mode: "solid",
  reveal_outline_color2: "#666666",
  card_surface_color: "#173b78",
  roulette_scale: 1,
  roulette_offset_x: 0,
  roulette_offset_y: 0,
  card_front_scale: 1,
  card_front_offset_x: 0,
  card_front_offset_y: 0,
};

export const CARD_SURFACE_PRESETS = [
  { id: "ocean", label: "Azul Oceano", color: "#2563eb" },
  { id: "sky", label: "Céu Turquesa", color: "#06b6d4" },
  { id: "mint", label: "Menta", color: "#10b981" },
  { id: "lime", label: "Lima", color: "#65a30d" },
  { id: "sun", label: "Sol", color: "#f59e0b" },
  { id: "tangerine", label: "Tangerina", color: "#f97316" },
  { id: "coral", label: "Coral", color: "#ef4444" },
  { id: "strawberry", label: "Morango", color: "#ec4899" },
  { id: "lavender", label: "Lavanda", color: "#a78bfa" },
  { id: "berry", label: "Mirtilo", color: "#7c3aed" },
];

function _hexToRgb(hex) {
  const h = (hex || "").replace("#", "");
  if (h.length !== 6) return { r: 23, g: 59, b: 120 };
  return { r: parseInt(h.slice(0, 2), 16), g: parseInt(h.slice(2, 4), 16), b: parseInt(h.slice(4, 6), 16) };
}
function _mix(hex, amount) {
  const { r, g, b } = _hexToRgb(hex);
  const t = (c) => Math.max(0, Math.min(255, Math.round(c + (amount > 0 ? (255 - c) : c) * amount)));
  return `rgb(${t(r)}, ${t(g)}, ${t(b)})`;
}
export function getCardSurfaceGradient(base) {
  const b = base || "#173b78";
  const light = _mix(b, 0.30);
  const dark = _mix(b, -0.50);
  return `radial-gradient(120% 110% at 50% 40%, ${light} 0%, ${b} 45%, ${dark} 100%)`;
}

// Convert hex → HSL (h: 0-360, s/l: 0-100)
function _hexToHsl(hex) {
  const h = (hex || "").replace("#", "");
  if (h.length !== 6) return { h: 220, s: 50, l: 30 };
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let H = 0, S = 0; const L = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    S = L > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) H = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) H = (b - r) / d + 2;
    else H = (r - g) / d + 4;
    H *= 60;
  }
  return { h: H, s: S * 100, l: L * 100 };
}

// Generate two decorative shape gradients from the card surface color palette.
// Kid-friendly: high saturation + bright luminance for a candy/cartoon feel that pops on any base.
export function getCardShapeColors(surfaceHex) {
  const { h } = _hexToHsl(surfaceHex || "#2563eb");
  const seed = Math.round(h);
  // Wider variety of pleasing hue offsets for playful unexpected pairings
  const OFFSETS = [60, 90, 120, 150, 180, 210, 240, 270, 300, 330];
  const off1 = OFFSETS[seed % OFFSETS.length];
  const off2 = OFFSETS[(seed + 4) % OFFSETS.length];
  const h1 = ((h + off1) % 360 + 360) % 360;
  const h2 = ((h + off2) % 360 + 360) % 360;
  // Bright, saturated, candy-like — higher luminance + slightly different blend angle
  return {
    shape1: `linear-gradient(155deg, hsl(${h1}, 92%, 72%) 0%, hsl(${h1}, 90%, 60%) 55%, hsl(${h1}, 85%, 48%) 100%)`,
    shape2: `linear-gradient(200deg, hsl(${h2}, 88%, 68%) 0%, hsl(${h2}, 86%, 55%) 55%, hsl(${h2}, 82%, 42%) 100%)`,
  };
}

// Build a layered drop-shadow filter that simulates a thin outer outline.
// Modes:
//   "solid"    — single color, smooth gradient fall-off (default)
//   "gradient" — 2-tone gradient: top-left direction uses color1, bottom-right uses color2 (radial blend)
export function getOutlineFilter(color = "#000000", width = 0.5, mode = "solid", color2 = "#666666") {
  const w = Math.max(0, Number(width) || 0);
  if (w === 0) return "drop-shadow(1px 2px 2px rgba(0,0,0,0.30))";
  const c1 = color;
  const c2 = color2;
  if (mode === "gradient") {
    return [
      // Top-half / left-half: color1
      `drop-shadow(-${w}px -${w}px 0 ${c1})`,
      `drop-shadow(0 -${w}px 0 ${c1})`,
      `drop-shadow(-${w}px 0 0 ${c1})`,
      `drop-shadow(${w}px -${w}px 0 ${c1})`,
      // Bottom-half / right-half: color2
      `drop-shadow(${w}px ${w}px 0 ${c2})`,
      `drop-shadow(0 ${w}px 0 ${c2})`,
      `drop-shadow(${w}px 0 0 ${c2})`,
      `drop-shadow(-${w}px ${w}px 0 ${c2})`,
      // Smooth blend halo
      `drop-shadow(0 0 ${w * 2}px ${c1}80)`,
      `drop-shadow(0 0 ${w * 4}px ${c2}40)`,
      "drop-shadow(1px 2px 2px rgba(0,0,0,0.30))",
    ].join(" ");
  }
  return [
    `drop-shadow(${w}px 0 0 ${c1})`,
    `drop-shadow(-${w}px 0 0 ${c1})`,
    `drop-shadow(0 ${w}px 0 ${c1})`,
    `drop-shadow(0 -${w}px 0 ${c1})`,
    `drop-shadow(${w}px ${w}px 0 ${c1})`,
    `drop-shadow(-${w}px ${w}px 0 ${c1})`,
    `drop-shadow(${w}px -${w}px 0 ${c1})`,
    `drop-shadow(-${w}px -${w}px 0 ${c1})`,
    `drop-shadow(0 0 ${w * 2}px rgba(0,0,0,0.45))`,
    `drop-shadow(0 0 ${w * 4}px rgba(0,0,0,0.20))`,
    "drop-shadow(1px 2px 2px rgba(0,0,0,0.30))",
  ].join(" ");
}

// text-shadow variant of the outline (for <span> elements like cycle quadrículas)
export function getOutlineTextShadow(color = "#000000", width = 0.5, mode = "solid", color2 = "#666666") {
  const w = Math.max(0, Number(width) || 0);
  if (w === 0) return "1px 2px 2px rgba(0,0,0,0.30)";
  const c1 = color;
  const c2 = color2;
  if (mode === "gradient") {
    return [
      `-${w}px -${w}px 0 ${c1}`, `0 -${w}px 0 ${c1}`, `-${w}px 0 0 ${c1}`, `${w}px -${w}px 0 ${c1}`,
      `${w}px ${w}px 0 ${c2}`, `0 ${w}px 0 ${c2}`, `${w}px 0 0 ${c2}`, `-${w}px ${w}px 0 ${c2}`,
      `0 0 ${w * 2}px ${c1}80`, `0 0 ${w * 4}px ${c2}40`,
      "1px 2px 2px rgba(0,0,0,0.30)",
    ].join(", ");
  }
  return [
    `${w}px 0 0 ${c1}`, `-${w}px 0 0 ${c1}`, `0 ${w}px 0 ${c1}`, `0 -${w}px 0 ${c1}`,
    `${w}px ${w}px 0 ${c1}`, `-${w}px ${w}px 0 ${c1}`, `${w}px -${w}px 0 ${c1}`, `-${w}px -${w}px 0 ${c1}`,
    `0 0 ${w * 2}px rgba(0,0,0,0.45)`, `0 0 ${w * 4}px rgba(0,0,0,0.20)`,
    "1px 2px 2px rgba(0,0,0,0.30)",
  ].join(", ");
}

export const REVEAL_EFFECTS = [
  { value: "spring", label: "Mola (escala + rotação)" },
  { value: "fade", label: "Aparecer (fade)" },
  { value: "slide_up", label: "Subir" },
  { value: "slide_down", label: "Descer" },
  { value: "zoom_in", label: "Zoom" },
  { value: "rotate", label: "Rodar" },
  { value: "flip", label: "Flip 3D" },
  { value: "none", label: "Sem efeito" },
];
